/* eslint-disable react/display-name */
import React, { createContext } from "react";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";
import { firebaseConfigs } from "../../firebaseConfig";

const FirebaseContext = createContext(null);
export { FirebaseContext };

const useFirebase = ({ children }) => {
  const firebaseConfig = firebaseConfigs()

  // if (location.hostname === "localhost") {

  //    firebaseConfig.databaseURL = {
  //     // Point to the RTDB emulator running on localhost.
  //     // In almost all cases the ns (namespace) is your project ID.
  //     databaseURL: "http://localhost:9000?ns=YOUR_DATABASE_NAMESPACE"
  //   }
  // }

  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
    firebase.auth().settings.appVerificationDisabledForTesting = true;
  }

  return (
    <FirebaseContext.Provider value={firebase}>
      {children}
    </FirebaseContext.Provider>
  );
};

export default useFirebase;
